import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function ConfiguringExcelCSV() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Configuring Your Data&nbsp;Source: Excel or CSV
      </Typography>

      <Typography paragraph>
        Follow these three steps:
      </Typography>

      <List className="steps-vertical" sx={{ ml: '2rem' }}>
        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            1&nbsp;·&nbsp;Click&nbsp;<strong>Choose&nbsp;File</strong> and pick an&nbsp;
            <code>.xls</code>, <code>.xlsx</code> or&nbsp;<code>.csv</code> file.
          </Typography>
          <img
            src="../../static/docs/XlsCsvSelectFile.jpg"
            alt="Select Excel/CSV file"
            className="step-img"
          />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            2&nbsp;·&nbsp;When the file loads successfully, the
            <strong>&nbsp;Next&nbsp;</strong> button lights up and the status turns&nbsp;green.
            If parsing fails, an error appears.
          </Typography>
          <img
            src="../../static/docs/CsvXlsFileSelected.jpg"
            alt="File loaded successfully"
            className="step-img"
          />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            3&nbsp;·&nbsp;  Clicking <b>Next</b> will prompt you to upload the file for future use. If you confirm, the file will be saved to your stored files.
          </Typography>
        </ListItem>
      </List>
    </Box>
  );
}